import { productRealPrice } from "../price/price.util";
import { skuProductItem } from "../product/product.util";
import { TrackTypes } from "./track";

declare const window: any;

const validateEventData = (event: TrackTypes, data: Record<string, any>): boolean => 
{
    switch (event) 
    {
        case TrackTypes.ViewContent:
        case TrackTypes.AddToCart:
            return !!data.product;
        case TrackTypes.Purchase:
            return (
                data.order &&
        data.order.id &&
        Array.isArray(data.order.items) &&
        data.order.items.length > 0
            );
        case TrackTypes.Lead:
            return !!data.lead_id;
        default:
            return true;
    }
};

export const thoughtmetricTrack = (
    eventId: string,
    externalId: string,
    event: TrackTypes,
    data: Record<string, any> = {}
) => 
{
    if (typeof window === "undefined" || typeof window.thoughtmetric !== "function") return;
    if (!validateEventData(event, data)) return;

    let eventData: any;

    switch (event) 
    {
        case TrackTypes.ViewContent:
        case TrackTypes.AddToCart:
            const price = productRealPrice(data?.product, data?.variant, false);
            const quantity = data?.quantity || 1;
            eventData = {
                content_id   : data?.product?.id || skuProductItem(data?.product, data?.variant),
                content_type : "product",
                content_name : data?.product?.name,
                quantity,
                price,
                value        : price * quantity,
                currency     : "BRL",
                contents     : [
                    {
                        product_name : data?.product?.name,
                        sku          : skuProductItem(data?.product, data?.variant),
                        quantity,
                        unit_price   : price,
                        discounts    : 0,
                        variant      : data?.variant?.name || ""
                    }
                ],
                event_id : eventId,
            };

            const eventName = event === TrackTypes.ViewContent ? "viewContent" : "addToCart";
            window.thoughtmetric("event", eventName, eventData);
            break;

        case TrackTypes.Lead: {
            eventData = {
                lead_id  : data.lead_id,
                status   : "submitted",
                event_id : eventId,
            };
            window.thoughtmetric("event", "lead", eventData);
            break;
        }

        case TrackTypes.Purchase: {
            const items = data.order.items.map((item: any) => ({
                product_name : item.name,
                sku          : item.id,
                quantity     : item.quantity,
                unit_price   : item.price,
                discounts    : item.discount || 0,
                variant      : item.variant || ""
            }));

            eventData = {
                transaction_id  : data.order.id,
                total_price     : data.order.total,
                subtotal_price  : data.order.subtotal,
                total_discounts : data.order.discount,
                total_shipping  : data.order.shipping,
                total_tax       : data.order.tax,
                item_quantity   : data.order.items.reduce((acc: number, i: any) => acc + i.quantity, 0),
                items,
                discount_codes  : data.order.discount_codes || [],
                status          : data.order.status || "paid",
                currency        : "BRL",
                orderCurrency   : "BRL",
                event_id        : eventId,
            };

            window.thoughtmetric("event", "order", eventData);
            break;
        }

        default:
            console.warn(`[ThoughtMetric] Evento ${event} não suportado.`);
            return;
    }

    return eventData;
};